var paywall = require("./lib/paywall");
setTimeout(() => paywall(12122844), 5000);

require("component-responsive-frame/child");
require("waypoints/lib/noframework.waypoints.min");

const triggers = document.querySelectorAll(".text-section"),
  width = document.getElementById("article").clientWidth,
  window_height = window.innerHeight,
  legend_boxes = document.querySelectorAll(".legend__f");

function updateFlightLegend(flight) {
  legend_boxes.forEach(function(box) {
    if (flight === "both") {
      box.classList.remove("inactive");
      box.classList.add("active");
    } else if (box.id === "legend__f--" + flight) {
      box.classList.remove("inactive");
      box.classList.add("active");
    } else {
      box.classList.remove("active");
      box.classList.add("inactive");
    }
  })
}

function hideImages() {
  let visible_figures = document.querySelectorAll(".boeing-shown")

  visible_figures.forEach(function(f) {
    f.classList.remove("boeing-shown");
    f.classList.add("boeing-hidden");
  });
}

triggers.forEach(function(t) {
  const step = t.id.split("--")[1],
    figure_selector = "figure--" + step,
    figure = document.getElementById(figure_selector),
    flight = t.getAttribute("data-flight");

  new Waypoint({
    element: t,
    offset: function() {
      if (width < 768) { // narrow screen
        return window_height - this.element.children[0].clientHeight;
      } else { // wide screen
        return 0.75 * window_height;
      }
    },
    handler: function(direction) {
      let flight = t.getAttribute("data-flight");
      updateFlightLegend(flight);

      if (direction === "down") {
        // if text is standalone
        if (t.classList.contains("standalone")) {
          hideImages();

        // if text goes with an image
        } else if (t.classList.contains("left")) {
          let step = t.id.split("--")[1],
            figure_selector = "figure--" + step,
            figure = document.getElementById(figure_selector);

          hideImages();
          figure.classList.remove("boeing-hidden");
          figure.classList.add("boeing-shown");
        }
      }
    }
  })

  new Waypoint({
    element: t,
    offset:function() {
      if (width < 768) { // narrow screen
        return -this.element.children[0].clientHeight - 200;
      } else { // wide screen
        return -0.75 * window_height;
      }
    },
    handler: function(direction) {
      if (direction === "up") {
        // if text is standalone
        if (t.classList.contains("standalone")) {
          hideImages();

        // if text goes with an image
        } else if (t.classList.contains("left")) {
          let step = t.id.split("--")[1],
            figure_selector = "figure--" + step,
            figure = document.getElementById(figure_selector);

          hideImages();
          figure.classList.remove("boeing-hidden");
          figure.classList.add("boeing-shown");          
        }
      }
    }
  })
});

new Waypoint({
  element: document.querySelector("#section--0"),
  offset: window_height,
  handler: function(direction) {
    if (direction === "up") {
      updateFlightLegend("both");
      hideImages();
    }
  }
})